// Module
var code = "<section class=\"{{ ::$ctrl.customClass }}\"> <hr class=\"details-divider\"/> <div>* {{ ::$ctrl.text.requiredField }}</div> </section> ";
// Exports
export default code;